import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
// import i18n from './i18n' // 暂时不需要多语言
Vue.config.productionTip = false

new Vue({
  // i18n,
  render: h => h(App)
}).$mount('#cookie-policy')
